import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import PlayerIconForm from './PlayerIconForm';
// import { initialValues  } from './initialValues-testing';
import { showPlayerIconApi, updatePlayerIconApi, clearEditedPlayerIcon } from './playerIconSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function PlayerIconUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.playerIcon);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'player-icons');
        dispatch(updatePlayerIconApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showPlayerIconApi({ navigate, id }));

        return () => dispatch(clearEditedPlayerIcon());
    }, []);

    return (
        <PlayerIconForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default PlayerIconUpdate;
